import { Component, Input, Output, EventEmitter, OnDestroy, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { Globals } from 'src/app/shared/globals/globals';
import { AuthorizationInfo } from 'src/app/shared/models/data/authInfo.model';
import { Group, GroupAuth, Groups, GroupToSave } from 'src/app/shared/models/data/groups.model';
import { BackendService } from 'src/app/shared/services/backend/backend.service';
import { TeiasoftLoaderService } from 'src/app/shared/services/teiasoft-bucket/teiasoft-loader.service';

@Component({
  selector: 'app-modal-group',
  templateUrl: './modal-group.component.html',
  styleUrls: ['./modal-group.component.scss']
})
export class ModalGroupComponent implements OnInit, OnDestroy, OnChanges {
  @Input() isMobile: boolean = false;
  @Input() theme: string = 'silver';
  @Input() action: string = 'create';
  @Input() groupId: number | null = null;
  @Input() authInfo: AuthorizationInfo = new AuthorizationInfo();

  @Output() closeModalGroup: EventEmitter<any> = new EventEmitter();

  topPx: number = 0;
  subscriptions: Subscription = new Subscription();
  group: Group = new Group();

  groupName: string = "";
  auths: string[] = new Array();
  offices: string[] = new Array();
  mills: string[] = new Array();
  groupToSave: GroupToSave = new GroupToSave();

  constructor(private teiasoftLoader: TeiasoftLoaderService, private backendService: BackendService, 
    public globals: Globals){
    this.topPx = window.scrollY;
  }
  
  ngOnInit(): void {

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes["action"]){
      this.action = changes["action"].currentValue;
      if (this.action == 'create'){
        this.group = new Group();
        this.groupName = "";
        if (!this.groupToSave) this.groupToSave = new GroupToSave();
      } 
    }

    if (changes && changes["groupId"]){
      if (changes["groupId"].currentValue != null){
        this.groupId = changes["groupId"].currentValue;
        this.getGroupById();
      }
    }

    if (changes && changes["authInfo"]){
      this.authInfo = new AuthorizationInfo();
      this.authInfo = changes["authInfo"].currentValue;
      //console.log("AuthInfo", this.authInfo);
      this.auths = new Array();
      for (const prop in this.authInfo.authorizationsAllowedUnitTypes!){
        this.auths.push(prop);
      }
      
      this.offices = new Array();
      for (var x=0; x < this.authInfo.offices!.length; x++){
        this.offices.push(this.authInfo.offices![x].officeCode!);
      }

      this.mills = new Array();
      for (var x=0; x < this.authInfo.mills!.length; x++){
        this.mills.push(this.authInfo.mills![x].shortName!);
      }

      this.auths = this.auths.sort((a,b) => (a > b) ? 1 : ((b > a ? -1 : 0)));
      this.offices = this.offices.sort((a,b) => (a > b) ? 1 : ((b > a ? -1 : 0)));
      this.mills = this.mills.sort((a,b) => (a > b) ? 1 : ((b > a ? -1 : 0)));
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
    this.groupName = "";
    this.group = new Group();
  }

  getGroupById(){
    this.teiasoftLoader.start();
    this.subscriptions.add(this.backendService.getGroups(this.groupId).subscribe(res => {
      this.group = new Group();
      this.group = res.groups![0];
      this.groupName = this.group.groupName!;
      if (!this.groupToSave) this.groupToSave = new GroupToSave();
      this.groupToSave.groupName = this.groupName;
      this.groupToSave.groupAuthorizations! = new Array();
      this.groupToSave.groupAuthorizations = JSON.parse(JSON.stringify(this.group.groupAuthorizations!));
      this.teiasoftLoader.stop();
    }));
  }

  saveGroup(){
    if (this.action == 'create'){
      this.teiasoftLoader.start();
      this.subscriptions.add(this.backendService.createGroup(this.groupToSave).subscribe(res => {
        this.teiasoftLoader.stop();
        this.closeModalGroup.emit('reload');
      }));
    } else {
      this.teiasoftLoader.start();
      this.subscriptions.add(this.backendService.updateGroup(this.groupToSave, this.groupId!).subscribe(res => {
        this.teiasoftLoader.stop();
        this.closeModalGroup.emit('reload');
      }));
    }
  }

  isDisabledSave():boolean{
    if (!this.groupToSave) return true;
    if (!this.groupToSave.groupName || this.groupToSave.groupName == '') return true;
    if (!this.groupToSave.groupAuthorizations || this.groupToSave.groupAuthorizations.length == 0) return true;
    for (var x=0; x < this.groupToSave.groupAuthorizations!.length; x++){
      if (!this.groupToSave.groupAuthorizations![x].authorizations || this.groupToSave.groupAuthorizations![x].authorizations!.length == 0) return true;
    }

    return false;
  }

  isPresent(unitType: string, i: number): boolean{
    //if (this.action == 'create'){
      for (const prop in this.authInfo.authorizationsAllowedUnitTypes!){
        if (prop == this.auths[i]){
          let _temp:string[] = new Array();
          _temp = this.authInfo.authorizationsAllowedUnitTypes[prop as keyof object];
          if (_temp.findIndex(x => x == unitType) == -1)
            return false;
          else
            return true;
        }
      }
      return false;
    //} else {

    //}
    
  }

  isChecked(unit: string, auth:string, unitType: string){
    if (!this.groupToSave) return false;
    if (!this.groupToSave.groupAuthorizations) return false;

    let _id: number | null = null;
    if (unitType == 'Office')
      _id = this.authInfo.offices!.filter(x => x.officeCode == unit)[0].officeId!;
    if (unitType == 'Mill')
      _id = this.authInfo.mills!.filter(x => x.shortName == unit)[0].millId!;

     if (!this.groupToSave.groupAuthorizations!.filter(x => x.unitId == _id && x.unitType == unitType)) return false;
    if (!this.groupToSave.groupAuthorizations!.filter(x => x.unitId == _id && x.unitType == unitType)[0]) return false;
    if (!this.groupToSave.groupAuthorizations!.filter(x => x.unitId == _id && x.unitType == unitType)[0].authorizations!) return false;

 
    if (this.groupToSave.groupAuthorizations!.filter(x => x.unitId == _id && x.unitType == unitType)[0].authorizations!.indexOf(auth) == -1)
      return false;
    else
      return true;
  }

  /* EVENTS */
  onSaveGroupClick(){
    this.saveGroup();
  }

  onCloseModalClick(){
    this.closeModalGroup.emit('');
  }

  onInputGroupName(evt: string){
    //if (evt.length < 5) return;
    this.groupName = evt;
    this.groupToSave.groupName = this.groupName;
  }

  onChkClicked(unit: string, auth:string, evt:any, unitType: string){
    if (!this.groupToSave) this.groupToSave = new GroupToSave();
    let _isChecked = evt.srcElement.checked;  
    if (!this.groupToSave.groupAuthorizations) this.groupToSave.groupAuthorizations = new Array();

    let _id: number | null = null;
    if (unitType == 'Office')
      _id = this.authInfo.offices!.filter(x => x.officeCode == unit)[0].officeId!;
    if (unitType == 'Mill')
      _id = this.authInfo.mills!.filter(x => x.shortName == unit)[0].millId!;

    // CHECK TRUE
    if (_isChecked){
      
      // Office/Mill
      if (unitType != 'Global'){
        let _iu: number = this.groupToSave.groupAuthorizations!.findIndex(x => x.unitId == _id && x.unitType == unitType);
        let _ia: number = _iu != -1 ? this.groupToSave.groupAuthorizations!.findIndex(x => x.unitId == _id && x.unitType == unitType && x.authorizations!.indexOf(auth) != -1) : -1;
        // Se non ho ancora unit inserite la aggiungo
        if (_iu == -1){
          let _item: GroupAuth = new GroupAuth();
          _item.unitId = _id!;
          _item.unitType = unitType;
          _item.authorizations = new Array();
          _item.authorizations.push(auth);
          this.groupToSave.groupAuthorizations.push(_item);
        }

        // Se ho unit ma non ho l'autorizzazione la aggiungo
        if (_iu != -1 && _ia == -1){
          if (!this.groupToSave.groupAuthorizations![_iu].authorizations) this.groupToSave.groupAuthorizations![_iu].authorizations = new Array();
          this.groupToSave.groupAuthorizations![_iu].authorizations!.push(auth);
        }
      } else {
        // Global
        let _iu: number = this.groupToSave.groupAuthorizations!.findIndex(x => x.unitType == 'Global');
        let _ia: number = _iu != -1 ? this.groupToSave.groupAuthorizations!.findIndex(x => x.unitType == 'Global' && x.authorizations!.indexOf(auth) != -1) : -1;
        // Se non ho ancora unit inserite la aggiungo
        if (_iu == -1){
          let _item: GroupAuth = new GroupAuth();
          _item.unitId = null;
          _item.unitType = 'Global';
          _item.authorizations = new Array();
          _item.authorizations.push(auth);
          this.groupToSave.groupAuthorizations.push(_item);
        }
        

        // Se ho unit ma non ho l'autorizzazione la aggiungo
        if (_iu != -1 && _ia == -1){
          if (!this.groupToSave.groupAuthorizations![_iu].authorizations) this.groupToSave.groupAuthorizations![_iu].authorizations = new Array();
          this.groupToSave.groupAuthorizations![_iu].authorizations!.push(auth);
        }
      }
    }

    // CHECK FALSE
    if (_isChecked == false){
      if (unitType != 'Global'){
        let _iu: number = this.groupToSave.groupAuthorizations!.findIndex(x => x.unitId == _id && x.unitType == unitType);
        this.groupToSave.groupAuthorizations![_iu].authorizations! = this.groupToSave.groupAuthorizations![_iu].authorizations!.filter(x => x != auth);
        // se non ho auth rimuovo anche la unit
        if (this.groupToSave.groupAuthorizations![_iu].authorizations!.length == 0){
          this.groupToSave.groupAuthorizations! = this.groupToSave.groupAuthorizations!.filter(x => x.unitId != _id);
        }
      }

      if (unitType == 'Global'){
        let _iu: number = this.groupToSave.groupAuthorizations!.findIndex(x => x.unitType == unitType);
        this.groupToSave.groupAuthorizations![_iu].authorizations! = this.groupToSave.groupAuthorizations![_iu].authorizations!.filter(x => x != auth);
        // se non ho auth rimuovo anche la unit
        if (this.groupToSave.groupAuthorizations![_iu].authorizations!.length == 0){
          this.groupToSave.groupAuthorizations! = this.groupToSave.groupAuthorizations!.filter(x => x.unitId != _id);
        }
      }
    }
  }

  /* UTILITIES */
  isEven(n:number): boolean{
    return n % 2 == 0;
  }
}
